export enum PressureUnit {
  Bar = 'bar',
  Kilopascal = 'kPa',
  Psi = 'PSI',
  MetresHead = 'mH2O',
  FeetHead = 'ftH2O',
}
